import React from 'react'
import { Button, Form, Input, message, Select, } from 'antd';
import { addPlayer } from '../../../http/modules/organization'
import './index.scss'
const { Option } = Select;

export default function PersonnelAdd() {

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const res = await addPlayer({
      "name": values.name,
      "gender": values.gender,
      "phone": values.phone,
      "work": values.work,
      "title": values.title,
      "email": values.email,
      "intro": values.intro,
    });
    if (res.code == 0) {
      message.success('添加成功')
      onReset()
    }
    else {
      message.error(`添加失败${res.msg}`)
    }
  };

  // 重置
  const onReset = () => {
    form.resetFields();
  };

  return (
    <div className='personnelAdd'>
      <header>
        <p></p>
        新增授课人
      </header>
      <Form
        form={form}
        name="basic"
        labelCol={{
          span: 3,
        }}
        wrapperCol={{
          span: 16,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="姓名"
          name="name"
          rules={[
            {
              required: true,
              message: '请输入正确姓名!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="性别"
          name="gender"
          rules={[
            {
              required: true,
              message: '请输入性别!',
            },
          ]}
        >
          <Select
            placeholder="请选择"
            // onChange={onGenderChange}
            allowClear
          >
            <Option key={'男'} value={'男'}>男</Option>
            <Option key={'女'} value={'女'}>女</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="手机"
          name="phone"
          rules={[
            { required: true, message: "请输入正确的手机号" },
            {
                pattern: new RegExp(/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/),
                message: "请输入正确的手机号！"
            }
        ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="职务"
          name="work"
          rules={[
            {
              required: true,
              message: '请输入职务!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="职称"
          name="title"
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="邮箱"
          name="email"
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="授课人/团队简介"
          name="intro"
          rules={[{ max: 500, message: '简介最多500字' }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="介绍授课人/团队擅长领域、相关工作经历、所获资质证书、荣誉等。"
            maxLength={500}
            showCount
          />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 3,
            span: 6,
          }}>
          <Button type="primary" htmlType="submit">
            确定
          </Button>
          <Button htmlType="button" onClick={onReset}>
            重置
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
